import union from 'lodash/union';

// Creates a reducer managing pagination, given the action types to handle,
// and a function telling how to extract the key from an action.
const inlinePaginate = ({ types, mapActionToKey }, skipPagination = false) => {
  if (!Array.isArray(types) || types.length !== 5) {
    throw new Error('Expected types to be an array of three elements.');
  }
  if (!types.every(t => typeof t === 'string')) {
    throw new Error('Expected types to be strings.');
  }

  const initialState = {
    isFetching: false,
    hasNextPage: false,
    pageCount: 0,
    totalPages: 0,
    ids: [],
    allIds: [],
  };

  const numPerPage = 6;

  const [ requestType, successType, failureType, nextPageType, resetType ] = types;

  const updatePagination = (state, action) => {
    switch (action.type) {
      case requestType:
        return {
          ...state,
          isFetching: true
        };
      case successType:
        const totalPages = !skipPagination ? Math.ceil(action.response.result.length / numPerPage) : 0;
        const pageCount = state.pageCount + 1;
        const allIds = action.response.result;
        return {
          ...state,
          isFetching: false,
          allIds,
          ids: !skipPagination ? union(state.ids, allIds.slice(0, numPerPage)) : allIds.slice(0),
          hasNextPage: pageCount < totalPages,
          pageCount,
          totalPages,
        };
      case failureType:
        return {
          ...state,
          isFetching: false
        };
      case nextPageType:
        const currentPageCount = state.pageCount + 1;
        return {
          ...state,
          ids: !skipPagination ? union(state.ids, state.allIds.slice((currentPageCount-1)*numPerPage, currentPageCount*numPerPage)) : state.allIds.slice(0),
          pageCount: currentPageCount,
          hasNextPage: currentPageCount < state.totalPages,
        };
      case resetType:
        return initialState;
      default:
        return state;
    }
  }

  return (state = initialState, action) => {
    // Update pagination
    switch (action.type) {
      case requestType:
      case successType:
      case failureType:
      case nextPageType:
      case resetType:
        return updatePagination(state, action);
      default:
        return state;
    }
  }
};

export default inlinePaginate;


// WEBPACK FOOTER //
// ./src/reducers/inline-paginate.js